import { isNil } from 'lodash-es';
import { useContext } from 'react';

import { PlatformContext } from './PlatformProvider';

const usePlatform = () => {
  const ctx = useContext(PlatformContext);

  if (isNil(ctx)) {
    throw new Error('usePlatform must be used within a PlatformProvider!');
  }

  return ctx;
};

export default usePlatform;
